<template>
  <div class="search_form" :class="{focus: input_focus}">
    <form @submit.prevent="submit">
      <div class="icon"></div>
      <input type="search" placeholder="検索" @focus="handleInputFocus">
      <div class="icon_close" v-show="input_focus" @click="inputBlur"></div>
    </form>
    
    <div class="search_result" v-show="input_focus">
      <div class="items_list white">
        <div class="item">
          <span class="text"><strong>施設: 4件</strong></span>
        </div>
        <div class="item">
          <span class="text"><strong>仙台</strong>市立病院</span>
        </div>
        <div class="item">
          <span class="text"><strong>仙台</strong>赤十字病院</span>
        </div>
        <div class="item">
          <span class="text">JCHO<strong>仙台</strong>病院</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'

export default {
  data () {
    return {
      input_focus: false
    }
  },
  methods: {
    ...mapActions({
      searchInstitutions: 'institution/searchInstitutions'
    }),
    submit () {
      this.$loading.show()
    },
    handleInputFocus () {
      this.input_focus = true
    },
    inputBlur () {
      this.input_focus = false
    }
  }
}
</script>

<style lang="scss">
  .search_form {
    .items_list {
      height: calc(100vh - 135px);
      overflow-y: scroll;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/search.vue